const MASTERS_ROUTES = {
    FETCH_CLIENT_NAME_AND_ID: 'masters/audit/client/companynames',
    FETCH_SCOPE_EXTENSION_CLIENTS: 'masters/audit/client/scope-extension',
    FETCH_SPECIAL_AUDIT_CLIENTS: 'masters/audit/client/special-audit'
}

export default MASTERS_ROUTES;